import { emptyStateStyles } from './empty-state.styles';

const CarIcon = () => (
	<svg
		className={emptyStateStyles.icon}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 002 12v4c0 .6.4 1 1 1h2"
		/>
		<circle cx="7" cy="17" r="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
		<circle cx="17" cy="17" r="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
	</svg>
);

CarIcon.displayName = 'CarIcon';

export { CarIcon };
